import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import styles from './visitorControl.module.scss';

export default function VisitorControl() {

  const { t } = useTranslation(['translation', 'visitorControl'])
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <>
      <Helmet>
        <title>{t("visitorControl:title")}</title>
        <meta name="description" content={t("visitorControl:metaDescription")} />
        <meta name="keywords" content={t("visitorControl:metaKeyWord")} />
        <link rel="canonical" href="https://silverman.app/price-and-package/visitor-control" />    
      </Helmet>

      <div className={styles.visitorControl}>
        <div className="text-address text-sm-center py-4">
          <h3 className="text-header" dangerouslySetInnerHTML={{ __html: t('visitorControl:Package of Visitor Control') }} />

          {/* Package of Visitor Control Management and Parking lot Service Fee */}

          {/* <p dangerouslySetInnerHTML={{ __html: t('visitorControl:Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tortor fermentum <br/> facilisis cum donec quis in. Scelerisque ornare eget et adipiscing in quis.') }} /> */}
        </div>
        {/* end section-1 */}

        <div>
          <div className="row mb-4 text-center visitor-control-package-wrapper">
            <div className="col-6 col-sm-3 offset-sm-3">
              <button className={`btn btn-link ${activeIndex === 0 ? 'active' : ''}`} onClick={() => setActiveIndex(0)}>
              <h5 className="visitorControltitle">{t("visitorControl:svmguard_pagkage")}</h5>
              </button>
            </div>
            <div className="col-6 col-sm-3 visitor-control-padding">
              <button className={`btn btn-link ${activeIndex === 1 ? 'active' : ''}`} onClick={() => setActiveIndex(1)}>
              <h5  className="visitorControltitle">{t("visitorControl:parking_pagkage")}</h5>
              </button>
            </div>
          </div>

          <div className="row pb-5">
            <div className="col-12 col-sm-8 offset-sm-2">
              {
                activeIndex === 0 &&  <Image src={asset('/images/visitorControl/Silverman-Guard.webp')} alt="Visitor control" className="d-block w-100 h-auto shadow" />
              }
              {
                activeIndex === 1 &&  <Image src={asset('/images/visitorControl/Silverman-Parking-Sharing.webp')} alt="Visitor control" className="d-block w-100 h-auto shadow" />
              }
            </div>
          </div>
        </div>
        {/* end section-2 */}

      </div>
    </>
  )

}